VjsAdmin.Sentry = (function () {
    const $table = $('#sentry-table');
    const init = function () {
        initSentryTable();
        new Main();
    };

    const Main = VjsUtility.Controller.extend({
        events: {
            'change #type-filter': 'quickTypeFilter',
            'change #date1-filter': 'quickTypeFilter',
            'change #date2-filter': 'quickTypeFilter',
        },
        quickTypeFilter() {
            $table.bootstrapTable('refresh', { url: '/api/sentry/' });
        },
    });

    const initSentryTable = function () {
        $table.bootstrapTable({
            ...VjsTable.simpleTableDefaults(),
            table: '#sentry-table',
            method: 'get',
            formatNoMatches() {
                return 'No sentry DNS AT ALL!!!';
            },
            idField: 'dns',
            showRefresh: true,
            showColumns: true,
            pagination: true,
            sidePagination: 'server',
            search: false,
            pageList: [500],
            pageSize: 500,
            toolbar: '#table-toolbar',
            icons: {
                refresh: 'fa-refresh',
            },
            sortName: 'name',
            sortOrder: 'desc',
            url: '/api/sentry/',
            columns: [
                {
                    title: 'Name',
                    field: 'name',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                    searchable: false,
                },
                {
                    title: 'DNS',
                    field: 'dns',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                    searchable: false,
                },
                {
                    title: 'Default',
                    field: 'default',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                    searchable: false,
                    formatter(value, row) {
                        const defaultDns = row.default;
                        if (defaultDns === '0') {
                            return 'No';
                        }
                        return 'Yes';
                    },
                },
                {
                    title: 'Actions',
                    field: 'action',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                    searchable: false,
                    formatter(value, row) {
                        return `<a href='/admin/testing-servers/sentry/delete/${row.id}' onclick="return confirm('You are about to delete ${row.name}. Click OK to continue.')" style='margin-right: 5px' class='testing-servers-delete text-danger' title='Delete'><i class='fa fa-trash' aria-hidden='true'></i></a>`;
                    },
                },
            ],
            responseHandler(res) {
                return {
                    total: res.meta.total ? res.meta.total : 0,
                    rows: res.data,
                };
            },
        });
    };

    return {
        init,
    };
}());
